module.exports = __webpack_public_path__ + "static/media/web_shuttle-ui@2x.7f28c51c.png";